import { connect, ConnectedProps } from "react-redux";

import { BoundingBox, IResult } from "redmond";
import { Dispatch } from "@reduxjs/toolkit";
import {
  setAmenitiesFilter,
  setFreeCancelFilter,
  setHotelNameFilter,
  setMapBound,
  setMaxPriceFilter,
  setStarRatingsFilter,
  setViewHotelsNearLocation,
} from "../../actions/actions";
import { AvailabilitySearchControl } from "./component";
import { IStoreState } from "../../../../reducers/types";

import {
  areHotelRequestParametersChanged,
  areRequestParametersChanged,
  getFilteredAndSortedHotelAvailabilityLodgings,
  getMapBound,
  initialFilterState,
} from "../../reducer";
import {
  getDepartureDate,
  getReturnDate,
  getDestination,
  getTravelers,
  getOrigin,
  getStopsOption,
  getFareclassOptionFilter,
} from "../../../search/reducer";

const mapStateToProps = (state: IStoreState) => ({
  lodgings: getFilteredAndSortedHotelAvailabilityLodgings(state),
  departureDate: getDepartureDate(state),
  returnDate: getReturnDate(state),
  searchLocation: getDestination(state),
  travelers: getTravelers(state),
  origin: getOrigin(state),
  stopsOptions: getStopsOption(state),
  mapBounds: getMapBound(state),
  areRequestParametersChanged: areRequestParametersChanged(state),
  areHotelRequestParametersChanged: areHotelRequestParametersChanged(state),
  fareclassOptionFilter: getFareclassOptionFilter(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setMapBound: (mapBound: BoundingBox | null) =>
    dispatch(setMapBound(mapBound)),
  setViewHotelsNearLocation: (location: IResult | null) =>
    dispatch(setViewHotelsNearLocation(location)),
  resetHotelFilters: () => {
    dispatch(setAmenitiesFilter(initialFilterState.amenities));
    dispatch(setFreeCancelFilter(initialFilterState.freeCancel));
    dispatch(setStarRatingsFilter(initialFilterState.starRatings));
    dispatch(setHotelNameFilter(initialFilterState.hotelName));
    dispatch(setMaxPriceFilter(initialFilterState.maxPrice));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AvailabilitySearchControlConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedAvailabilitySearchControl = connector(
  AvailabilitySearchControl
);
